<template>
	<div
    style="position: relative;"
  >
    <div
      v-if="xcase"
      style="display: flex;align-content: center;align-items: center;height: 80px;background:#ECEFF1;"
      :class="{'closed': xcase && !xcase.active}"
    >
      <v-btn
        icon
        @click="$emit('back')"
      >
        <v-icon>
          mdi-chevron-left
        </v-icon>
      </v-btn>
      <div
        v-if="activeChecklistItems().length > 0"
      >
        <v-progress-circular
          v-if="checklistPercentComplete() < 100"
          :value="checklistPercentComplete()"
          :color="getDomainInfo.primary_color"
          style="margin-right: 20px;"
        >
          {{ checklistPercentComplete() }}
        </v-progress-circular>
        <v-progress-circular
          v-else
          :value="100"
          :color="getDomainInfo.primary_color"
          style="margin-right: 20px;"
        >
          <v-icon
            color="rgb(46, 125, 50)"
            style="margin-top: 2px;"
          >
            mdi-check-circle
          </v-icon>
        </v-progress-circular>
      </div>
      <div
        style="flex-grow: 1;display: column;"
      >
        <div
          v-if="xcase && xcase.case_type"
          style="font-size:18px;"
        >
          <b>{{ xcase.case_type.name }}</b>
        </div>
        <div>
          <span
            v-if="xcase && xcase.case_number"
          >
            <span
              style="font-weight: bold;margin-right: 10px;"
            >
              {{ xcase.case_number }}
            </span>
          </span>
          <span
            v-if="xcase && xcase.case_title"
          >
            {{ xcase.case_title }}
          </span>
          <v-fade-transition>
            <v-chip
              v-if="!xcase.active"
              small
              color="#F44336"
              dark
              style="margin-right:10px;"
            >
              Closed
            </v-chip>
          </v-fade-transition>
        </div>
      </div>
      <div
        v-if="!loading"
      >
        <v-btn
          v-if="checkPermission('cases', PERMISSIONS.CAN_EDIT)"
          color="dark"
          style="margin:auto;margin-right: 10px;"
          flat
          @click="editCase = true"
        >
          Edit
        </v-btn>
        <v-btn
          v-if="checkPermission('userform', PERMISSIONS.CAN_CREATE)"
          color="primary"
          style="margin:auto;margin-right: 25px;"
          flat
          @click="addForm = true"
        >
          Add Form
        </v-btn>
      </div>
    </div>
    <v-expand-transition>
      <v-progress-linear
        v-if="loading"
        indeterminate
        style="padding:0;margin:0;"
      />
    </v-expand-transition>
    <v-tabs
      v-if="activeChecklistItems().length > 0"
      v-model="tabIndex"
    >
      <v-tab
        key="forms"
      >
        Forms
      </v-tab>
      <v-tab
        key="progress"
      >
        Progress
      </v-tab>
    </v-tabs>
    <v-tabs-items
      v-if="xcase"
      v-model="tabIndex"
    >
      <v-tab-item
        key="forms"
      >
        <div
          style="padding:10px;"
        >
          <v-card-text>
            <v-layout>
              <v-flex
                xs12
                sm6
                md3
              >
              <b>Form</b>
              </v-flex>
              <v-flex
                xs12
                sm6
                md3
              >
              <b>Status</b>
              </v-flex>
              <v-flex
                xs12
                sm6
                md3
              >
              <b>Date Issued</b>
              </v-flex>
              <v-flex
                xs12
                sm6
                md3
              >
              <b>Last Updated</b>
              </v-flex>
            </v-layout>
          </v-card-text>
          <div
            v-if="xcase"
          >
            <div
              v-if="xcase.userforms.length > 0"
            >
              <v-card
                v-for="uf in xcase.userforms"
                :key="uf.id"
                style="margin-bottom: 15px;"
              >
                <UserFormRow
                  :userform="uf"
                />
              </v-card>
            </div>
            <div
              v-else
              style="text-align:center;padding: 15%;font-size: 16px;"
            >
              <v-icon size="64">mdi-briefcase-outline</v-icon><br />
              <b>This case is empty</b><br />
              Add a form to get started
            </div>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item
        key="progress"
        style="margin:20px;"
      >
        <div
          style="font-size: 16px;font-weight: bold;margin-bottom: 0 !important;"
        >
          Case Progress
        </div>
        <div>
          <div
            v-for="item in activeChecklistItems()"
            :key="item.id"
            :class="{'optional': !item.optional && !item.default && !checklistItemChecked(item.id)}"
            style="display: flex;margin-bottom: 5px;align-items: center;"
          >
            <v-checkbox
              style="flex-grow: 0;"
              :input-value="checklistItemChecked(item.id)"
              :disabled="checklistSaving"
              @change="updateChecklist(item.id, !checklistItemChecked(item.id))"
            />
            <div>
              <div
                style="font-size: 14px;color: #262626;"
              >
                {{ item.title }}
              </div>
              <div
                style="font-size: 14px;color: #757575;"
              >
                {{ item.subtitle }}
              </div>
            </div>
          </div>
          <div
            v-if="inactiveChecklistItems().length > 0"
            style="margin-top: 20px; text-align: center;"
          >
            <v-btn
              color="primary"
              flat
              :disabled="checklistSaving"
              @click="showAddChecklistDialog = true"
            >
              Add Optional Checklist Item(s)
            </v-btn>
            <v-dialog
              v-model="showAddChecklistDialog"
              max-width="500"
            >
              <v-card>
                <v-card-title>
                  <div
                    style="font-size: 20px;"
                  >
                    Add Optional Checklist Item(s)
                  </div>
                  <div
                    style="font-size: 14px;color: #757575;margin-top: 5px;"
                  >
                    Checklist items will be added with their default checked/unchecked value.
                  </div>
                </v-card-title>
                <v-card-text>
                  <v-list>
                    <v-list-tile
                      v-for="item in inactiveChecklistItems()"
                      :key="item.id"
                    >
                      <v-list-tile-action>
                        <v-checkbox
                          v-model="selectedOptionalChecklistItems"
                          :value="item.id"
                          style="display:inline-block;"
                        />
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    flat
                    @click="showAddChecklistDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    @click="addSelectedOptionalChecklistItems()"
                  >
                    Add
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog
      v-model="addForm"
      persistent
      width="800"
    >
      <v-card
        style="position:relative;height: 455px;overflow:hidden;"
      >
        <v-fade-transition>
          <form-template-select
            v-if="addForm && !confirmTemplate"
            :caseType="xcase.case_type.id"
            @select="addFormToCase"
            @confirm="checkConfirmTemplate"
            @cancel="addForm = false"
          />
        </v-fade-transition>
        <v-fade-transition>
          <div
            v-if="addForm && confirmTemplate"
          >
            <v-card-text>
              <FormTemplatePreview
                :id="addTemplate.template_id"
              />
              <v-text-field
                v-model="addTemplate.party_name"
                persistent-hint
                autofocus
                solo
                hint="Party Name - The Party's Name that this Form will be assigned to; ex. Injured Party"
              />
              <v-text-field
                v-model="addTemplate.form_number"
                persistent-hint
                solo
                hint="Form Number - An identifier for this Form related to the Party"
              />
              <br />
              <v-combobox
                v-model="addTemplate.tags"
                :items="tagResults"
                :search-input.sync="tagSearch"
                multiple
                persistent-hint
                hint="Form Tags"
                item-text="tag"
                item-value="tag"
                :return-object="false"
                solo
                small-chips
                hide-selected
                auto-select-first
                @input="tagSearch = ''"
              />
            </v-card-text>
          </div>
        </v-fade-transition>
        <v-card-actions
          style="position: absolute;bottom:0;left:0;right:0;"
        >
            <v-spacer />
            <v-btn
                flat
                @click="confirmTemplate ? confirmTemplate=false : addForm = false;addTemplate=null"
            >
              {{ confirmTemplate ? 'Back' : 'Cancel' }}
            </v-btn>
            <v-btn
                color="primary"
                :disabled="!addTemplate"
                @click="confirmTemplate ? postTemplateToCase() : confirmTemplate = true"
            >
              {{ confirmTemplate ? 'Add Form' : 'Next' }}
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editCase"
      persistent
      width="400"
    >
      <v-fade-transition>
        <v-card
          v-if="editCase"
        >
          <CaseSettings
            :xcase="xcase"
            @cancel="editCase = false"
            @save="editCase = false;fetchCase()"
          />
        </v-card>
      </v-fade-transition>
    </v-dialog>
	</div>
</template>

<script>
import api from '@/api'
import FormTemplateSelect from '../formtemplate/FormTemplateSelect.vue'
import FormTemplatePreview from '../formtemplate/FormTemplatePreview.vue'
import UserFormRow from '../userform/UserFormRow.vue'
import CaseSettings from '../cases/CaseSettings.vue'
import { mapGetters } from 'vuex'

export default {
    name: "CaseView",
    components: {
      FormTemplateSelect,
      FormTemplatePreview,
      UserFormRow,
      CaseSettings
    },
    props: ['selected'],
    data () {
      return {
        xcase: null,
        addForm: false,
        addTemplate: null,
        tagSearch: null,
        tagResults: [],
        confirmTemplate: false,
        loading: false,
        editCase: false,
        tabIndex: 0,
        showAddChecklistDialog: false,
        selectedOptionalChecklistItems: [],
        checklistSaving: false
      }
    },
    watch: {
      tagSearch () {
        if (this.tagSearch) {
          this.fetchTags()
        }
      }
    },
    computed: {
      ...mapGetters('auth', [
        'getDomainInfo',
      ]),
    },
    methods: {
      checklistOptionalAdded (id) {
        if (this.xcase && this.xcase.checklist) {
          const checkedEntry = this.xcase.checklist.find(c => c.item.id === id)
          return checkedEntry
        }
        return false
      },
      checklistItemChecked (id) {
        if (this.xcase && this.xcase.checklist) {
          const checkedEntry = this.xcase.checklist.find(c => c.item.id === id)
          return checkedEntry ? !!checkedEntry.value : false
        }
        return false
      },
      incompleteChecklistItems () {
        if (this.xcase && this.xcase.checklist_items) {
          return this.xcase.checklist_items.filter(i => !this.checklistItemChecked(i.id) && (!i.optional || (i.optional && this.checklistOptionalAdded(i.id))) )
        }
        return []
      },
      checklistPercentComplete () {
        if (this.xcase && this.xcase.checklist_items && this.xcase.checklist_items.length > 0) {
        const relevantItems = this.xcase.checklist_items.filter(
            i => !i.optional || (i.optional && this.checklistOptionalAdded(i.id))
        )
        const completed = relevantItems.filter(i => this.checklistItemChecked(i.id)).length
        return relevantItems.length > 0
          ? Math.round((completed / relevantItems.length) * 100)
          : 0
        }
        return 0
      },
      activeChecklistItems () {
        if (this.xcase && this.xcase.checklist_items) {
            return this.xcase.checklist_items.filter(i => !i.optional || (i.optional && this.checklistOptionalAdded(i.id)) )
        }
        return []
      },
      inactiveChecklistItems () {
        if (this.xcase && this.xcase.checklist_items) {
          return this.xcase.checklist_items.filter(
            i => i.optional && !this.checklistOptionalAdded(i.id)
          )
        }
        return []
      },
      addSelectedOptionalChecklistItems() {
        if (this.selectedOptionalChecklistItems.length > 0) {
          this.selectedOptionalChecklistItems.forEach(id => {
            const item = this.xcase.checklist_items.find(i => i.id === id)
            this.updateChecklist(id, item.default)
          })
          this.selectedOptionalChecklistItems = []
        }
        this.showAddChecklistDialog = false
      },
      fetchCase () {
        this.loading = true
        api.cases.cases.get(this.selected)
          .then(xcase => {
            this.xcase = xcase
          })
          .finally(() => {
            this.loading = false
          })
      },
      checkConfirmTemplate () {
        if (this.addTemplate && this.addTemplate.template_id)
          this.confirmTemplate = true
      },
      updateChecklist(checklistItemId, value) {
        this.checklistSaving = true
        api.cases.cases.updateProgress(this.xcase, checklistItemId, value)
          .then(updatedChecklistItem => {
            if (this.xcase && this.xcase.checklist) {
              const idx = this.xcase.checklist.findIndex(c => c.item.id === updatedChecklistItem.item.id)
              if (idx !== -1) {
                this.$set(this.xcase.checklist, idx, updatedChecklistItem)
              } else {
                this.xcase.checklist.push(updatedChecklistItem)
              }
            }
          })
          .finally(() => {
            this.checklistSaving = false
          })
      },
      postTemplateToCase () {
        api.cases.cases.addUserForm(this.xcase, ...Object.values(this.addTemplate))
          .then(xcase => {
            this.addTemplate = null
            this.confirmTemplate = false
            this.addForm = false
            this.fetchCase()
          })
      },
      fetchTags () {
        api.userform.contactTags.get(this.tagSearch)
          .then(tagResults => {
            this.tagResults = tagResults
          })
      },
      addFormToCase (template_id) {
        if (!template_id)
          return
        this.addTemplate = {
          template_id: template_id,
          form_number: null,
          party_name: null,
          tags: []
        }
      }
    },
    created () {
      if (this.selected)
        this.fetchCase()
    }
}
</script>

<style scoped>

.closed {
  background: #FFEBEE !important;
}

</style>